// extracted by mini-css-extract-plugin
export default {"wrap":"AdminSellerPicker_wrap__EtI0R","label":"AdminSellerPicker_label__l-gA2","select":"AdminSellerPicker_select__+aRan","refreshBtn":"AdminSellerPicker_refreshBtn__0Op-j"};